import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./app/store";
import "./index.css";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { ToastProvider } from "react-toast-notifications";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "swiper/swiper-bundle.min.css";
import { ApolloProdviderClient } from "./Wrappers/apolloClient";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { CompareProvider } from "./context/CompareContext";
import "font-awesome/css/font-awesome.min.css";
import { BrowserRouter as Router } from "react-router-dom";

let persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider
          autoDismiss
          autoDismissTimeout={4000}
          placement="top-center"
        >
          <ApolloProdviderClient>
            <CompareProvider>
              <Router>
                <App />
              </Router>
            </CompareProvider>
          </ApolloProdviderClient>
        </ToastProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorkerRegistration.unregister();
